import {VerifiedAttribute} from './VerifiedAttribute';
import {Language} from '../enums/Language';
import {Child} from "./Child";
import {PurchasedSubscription} from "./PurchasedSubscription";
import { Roles } from 'src/app/enums/Roles';

export class User {
  public id: number;
  public name: string;
  public firstName: string;
  public lastName: string;
  public phone: VerifiedAttribute;
  public userStatus: string;
  public email: VerifiedAttribute;
  public tokens: number;
  public activeOrders: number;
  public language: Language;
  public registrationDate: Date;
  public confirmationDate: Date;
  public confirmed: boolean;
  public coffeeCups: number;
  public roles: string[];
  public userId: number;
  public children: Child[];
  public subscriptions: PurchasedSubscription[];

  public constructor(init?: Partial<User>) {
    Object.assign(this, init);
  }

}

export function formatRoles(user: User): string {
  return user.roles.map(role => Roles[role]).join(', ');
}
